(function() {
    'use strict';

a3_cabin_reports.factory('UserTokenFactory', UserTokenFactory);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name UserTokenFactory
    * @description 
    *  Used to maintain the user token, outside the localStorage, in order to be accessible from the service which logs js errors
    * /(this service may not use localstorage provider)
    * @ngInject
    */
function UserTokenFactory() {
		return {
			 token: '',
            
			setToken: function(value) {
				this.token = value;
			},

			getToken: function() {
				return this.token;
			}
		};
	}

})();